// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"507":"privacyAgreement","890":"userAgreement"}[chunkId] + "." + {"507":"a638b057","890":"222b9d90"}[chunkId] + ".js";
};